import MediaZoomItem from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/MediaZoomItem/MediaZoomItem';

export default MediaZoomItem;
